import { Typography } from '@mui/material';
import { useMemo } from 'react';
import { useStyles } from './styles/SystemManagement.styles';
import { BreadcrumbSubBar } from '@components/BreadcrumbSubBar';
import { Hint } from '@components/Hint';
import { flattenIdMap } from '@utils/object';
import { SystemTable } from '@components/SystemManagement/SystemTable';
import { useNameMapQuery } from '@features/redux/apis/org';
import { useSelector } from 'react-redux';

import type { Location } from '@/types/locations';

import type { RootState } from '@features/redux/store';

export const SystemManagement = () => {
    const classes = useStyles();
    const { data: nameMap } = useNameMapQuery({});
    const role = useSelector((state: RootState) => state.auth.Roles.role);
    const canEdit = role.isAdmin && role.stores.edit;

    const formattedLocations = useMemo(() => {
        return flattenIdMap<Location>({ idKey: 'locationId', valueKey: 'locationName' }, nameMap?.locations ?? {});
    }, [nameMap?.locations]);

    return (
        <div className={classes.root}>
            <Typography className={classes.dashboardTitle} component='h1'>
                Manage RapidCut Systems
            </Typography>

            <Hint
                text={`Below is a list of${
                    canEdit ? '' : ' your'
                } RapidCut Systems, along with the Company, Reseller, and Location information in relation to them.${
                    canEdit ? ' Click any of the results to further view & edit them.' : ''
                }`}
            />

            <BreadcrumbSubBar />

            <SystemTable mode='assigned' formattedLocations={formattedLocations} edit={canEdit} />

            <SystemTable mode='unassigned' edit={canEdit} />
        </div>
    );
};
